import styled from 'styled-components';

export const Icon = styled.img`
  max-width: 50%;
  height: auto;
`;
